import type { ReactNode } from "react";
import { Shell } from "@mypos/ui";
import { ManagerSidebar } from "./ManagerSidebar";
import { ManagerTopbar } from "./ManagerTopbar";

export function ManagerShell({ children }: { children: ReactNode }) {
  return (
    <Shell sidebar={<ManagerSidebar />} topbar={<ManagerTopbar />}>
      {children}
    </Shell>
  );
}
